import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper } from '@material-ui/core';
import LabResultComponent from './LabResultComponent';
import { FieldArray } from 'react-final-form-arrays'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      marginBottom: theme.spacing(4),
    },
    table: {
      margin: 'auto',
    },
  }),
);

export default function LabResultTable() {
  const classes = useStyles();

  // TODO: scale={(x) => x ** 10} when the value is super off.
  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} aria-label="Lab results">
        <TableHead>
          <TableRow>
            <TableCell align="center">Visible</TableCell>
            <TableCell align="center">Code</TableCell>
            <TableCell align="center">Name</TableCell>
            <TableCell align="center">Range</TableCell>
            <TableCell align="center">Result</TableCell>
            <TableCell align="center">Units</TableCell>
            <TableCell align="center">Computed normality</TableCell>
            <TableCell align="center">Physician normality</TableCell>
            <TableCell align="center">Comments</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray subscription={{}} name="components">
            {({ fields }) =>
              fields.map((name, index) => (
                <LabResultComponent key={index} name={name}/>
              ))
            }
          </FieldArray>
        </TableBody>
      </Table>
    </TableContainer>
  );
}